import { cn } from "@/lib/utils";

/** Approved app icon: orange rounded square, white house with rising bars. */
export function AppMark({ className, testId }: { className?: string; testId?: string }) {
  return (
    <img
      src="/icons/icon-192.png"
      alt=""
      width={192}
      height={192}
      aria-hidden
      draggable={false}
      data-testid={testId}
      className={cn("h-7 w-7 shrink-0 select-none", className)}
    />
  );
}
